document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initSwatches();
  initGaleriaProducto();
  initCantidadProducto();
  initVariantesProducto();
  initComprarAhora();
});

function initComprarAhora() {
  document.querySelectorAll('[data-mt-comprar-ahora]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      if (boton.getAttribute('aria-busy') === 'true') return;
      var form = boton.closest('form');
      var variantInput = form ? form.querySelector('[data-mt-variant-id]') : null;
      var cantidadInput = form ? form.querySelector('[data-mt-cantidad-input]') : null;
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      var cantidad = cantidadInput ? (parseInt(cantidadInput.value, 10) || 1) : 1;
      boton.setAttribute('aria-busy', 'true');
      var textoOriginal = boton.textContent;
      boton.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: cantidad }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || 'error'); });
          window.location.href = '/checkout';
        })
        .catch(function () {
          boton.removeAttribute('aria-busy');
          boton.textContent = textoOriginal;
          window.location.href = '/cart';
        });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      el.textContent = '0';
      var dur = 1400;
      var t0 = null;
      function frame(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var val = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = (Number.isInteger(fin) ? Math.round(val) : val.toFixed(1)).toString();
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = fin.toString();
      }
      requestAnimationFrame(frame);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');
  if (!miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var wrap = mini.closest('.mt-producto');
      if (!wrap) return;
      var principal = wrap.querySelector('.mt-producto__img-principal img');
      if (principal) principal.src = mini.getAttribute('data-full');
      wrap.querySelectorAll('[data-mt-miniatura]').forEach(function (m) {
        m.classList.remove('mt-producto__miniatura--activa');
      });
      mini.classList.add('mt-producto__miniatura--activa');
    });
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-mt-cantidad-input]').forEach(function (input) {
    var wrap = input.closest('.mt-producto__cantidad');
    if (!wrap) return;
    var menos = wrap.querySelector('[data-mt-cantidad-menos]');
    var mas = wrap.querySelector('[data-mt-cantidad-mas]');
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}

function initVariantesProducto() {
  var raiz = document.querySelector('mt-producto');
  if (!raiz) return;
  var jsonEl = document.querySelector('[data-mt-variantes-json]');
  if (!jsonEl) return;
  var variantes;
  try { variantes = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  var grupos = raiz.querySelectorAll('[data-mt-opcion-nombre]');
  var inputId = raiz.querySelector('[data-mt-variant-id]');
  var precioActual = raiz.querySelector('[data-mt-precio-actual]');
  var precioAntes = raiz.querySelector('[data-mt-precio-antes]');
  var boton = raiz.querySelector('[data-mt-boton-comprar]');
  var botonTexto = raiz.querySelector('[data-mt-boton-texto]');
  var imagenPrincipal = raiz.querySelector('.mt-producto__img-principal img');

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
    });
  }

  function seleccionActual() {
    var valores = [];
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-opcion--activa');
      valores.push(activo ? activo.getAttribute('data-mt-valor') : null);
    });
    return valores;
  }

  function encontrarVariante() {
    var seleccion = seleccionActual();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar(indiceGrupoCambiado) {
    var variante = encontrarVariante();
    if (!variante && typeof indiceGrupoCambiado === 'number') {
      var valorCambiado = seleccionActual()[indiceGrupoCambiado];
      variante = variantes.find(function (v) { return v.options[indiceGrupoCambiado] === valorCambiado; });
      if (variante) {
        grupos.forEach(function (grupo, i) {
          if (i === indiceGrupoCambiado) return;
          var valorReal = variante.options[i];
          grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) {
            b.classList.toggle('mt-opcion--activa', b.getAttribute('data-mt-valor') === valorReal);
          });
        });
      }
    }
    if (!variante) {
      if (boton) boton.disabled = true;
      if (botonTexto) botonTexto.textContent = raiz.dataset.mtNoDisponible || 'No disponible';
      return;
    }
    if (inputId) inputId.value = variante.id;
    if (precioActual) precioActual.textContent = formatearDinero(variante.price);
    if (precioAntes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntes.textContent = formatearDinero(variante.compare_at_price);
        precioAntes.style.display = '';
      } else {
        precioAntes.style.display = 'none';
      }
    }
    if (boton && botonTexto) {
      boton.disabled = !variante.available;
      botonTexto.textContent = variante.available ? botonTexto.dataset.textoDisponible || botonTexto.textContent : (boton.dataset.textoAgotado || 'Agotado');
    }
    if (imagenPrincipal && variante.featured_image && variante.featured_image.src) {
      var srcBase = variante.featured_image.src;
      var sep = srcBase.indexOf('?') > -1 ? '&' : '?';
      var srcConAncho = srcBase + sep + 'width=1200';
      imagenPrincipal.src = srcConAncho;
      var miniaturaCoincide = null;
      raiz.querySelectorAll('[data-mt-miniatura]').forEach(function (m) {
        m.classList.remove('mt-producto__miniatura--activa');
        var full = m.getAttribute('data-full') || '';
        if (full.indexOf(srcBase.split('?')[0]) === 0 || full === srcConAncho) miniaturaCoincide = m;
      });
      if (miniaturaCoincide) miniaturaCoincide.classList.add('mt-producto__miniatura--activa');
    }
  }

  grupos.forEach(function (grupo, indiceGrupo) {
    grupo.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-opcion--activa'); });
        btn.classList.add('mt-opcion--activa');
        actualizar(indiceGrupo);
      });
    });
  });
}

function initSwatches() {
  var groups = document.querySelectorAll('[data-mt-swatch-group]');
  groups.forEach(function (group) {
    var swatches = group.querySelectorAll('[data-mt-swatch]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('mt-swatch--activo'); });
        sw.classList.add('mt-swatch--activo');
      });
    });
  });
}
